import React, { useEffect, useState } from 'react';
import { Brushaway } from '../../molecules/Brushaway/Brushaway';
import { BrushawayHeader } from '../../molecules/Brushaway/BrushawayHeader';
import { BrushawayBody } from '../../molecules/Brushaway/BrushawayBody';
import { BrushawayFooter } from '../../molecules/Brushaway/BrushawayFooter';
import { Button } from '../../atoms/Button/Button';
import { TextInput } from '../../molecules/inputs/form/TextInput/TextInput';
import './AddCategoryBrushawayStyles.scss';
const INPUT_ID = 'qmb-ui-add-category-brushaway-name';
const DESCRIPTION_ID = 'qmb-ui-add-category-brushaway-description';
/**
 * "Add new category" drawer, opened from the attachments category dropdown's footer action.
 *
 * Storage-agnostic in the same way `AddAttachmentsBrushaway` is: it never calls an API itself.
 * The consumer owns the request, the saving flag and the error text, so the created category can
 * be pushed into that consumer's own option list and auto-selected on the row that opened it.
 */
export function AddCategoryBrushaway({ open, isSaving = false, errorMessage = null, onErrorDismiss, onSubmit, onClose, labels, className }) {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    // Reopening must not show the previous attempt's text.
    useEffect(() => {
        if (open) {
            setName('');
            setDescription('');
        }
    }, [open]);
    const canSubmit = name.trim().length > 0 && !isSaving;
    const handleSubmit = () => {
        if (!canSubmit)
            return;
        onSubmit({ name: name.trim(), description: description.trim() });
    };
    const rootClassName = ['qmb-ui-add-category-brushaway', className].filter(Boolean).join(' ');
    return (React.createElement(Brushaway, { controlledOpen: open, onClose: onClose, className: rootClassName },
        React.createElement(BrushawayHeader, { title: labels.title, closeLabel: labels.closeLabel }),
        React.createElement(BrushawayBody, null,
            React.createElement("div", { className: "qmb-ui-add-category-brushaway__form" },
                React.createElement(TextInput, { id: INPUT_ID, label: labels.nameLabel, placeholder: labels.namePlaceholder, value: name, disabled: isSaving, error: errorMessage !== null && errorMessage !== void 0 ? errorMessage : undefined, onChange: (event) => {
                        setName(event.target.value);
                        if (errorMessage)
                            onErrorDismiss === null || onErrorDismiss === void 0 ? void 0 : onErrorDismiss();
                    }, onKeyDown: (event) => {
                        if (event.key === 'Enter') {
                            event.preventDefault();
                            handleSubmit();
                        }
                    } }),
                React.createElement(TextInput, { id: DESCRIPTION_ID, label: labels.descriptionLabel, placeholder: labels.descriptionPlaceholder, value: description, disabled: isSaving, onChange: (event) => setDescription(event.target.value) }))),
        React.createElement(BrushawayFooter, null,
            React.createElement(Button, { onClick: onClose, disabled: isSaving }, labels.cancelLabel),
            React.createElement(Button, { variant: "primary", disabled: !canSubmit, onClick: handleSubmit }, labels.submitLabel))));
}
